import { render, staticRenderFns } from "./DAuthHeader.vue?vue&type=template&id=e764cc3e&scoped=true&"
import script from "./DAuthHeader.vue?vue&type=script&lang=js&"
export * from "./DAuthHeader.vue?vue&type=script&lang=js&"
import style0 from "./DAuthHeader.vue?vue&type=style&index=0&id=e764cc3e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e764cc3e",
  null
  
)

export default component.exports